import { NextImage } from '@apeiron/temp'
import { Button, styled } from '@mui/material'
import BackSVG from '@public/icons/icon-back-button.svg'
import { ROUTE } from '@src/constants/route'
import { useHistoryContext } from '@src/contexts/share/HistoryContext'
import { useRouter } from 'next/router'
import * as R from 'ramda'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const StyledIcon = styled(NextImage)`
  fill: #ffffff;
  height: 16px;
  width: 12px;
`

const StyledButton = styled(Button)`
  color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  text-transform: none;
`

const ApeironBackButton: React.FC<Props> = props => {
  const { url, className, onClick } = props

  const { history } = useHistoryContext()

  const router = useRouter()

  const { t } = useTranslation()

  const handleOnClick = useCallback(() => {
    if (R.isNotNil(url)) {
      router.replace(url)
    } else if (R.isEmpty(history)) {
      router.replace(ROUTE.HOME)
    } else {
      router.back()
    }
  }, [url, history, router])

  return (
    <StyledButton
      className={className}
      startIcon={<StyledIcon src={BackSVG} />}
      onClick={onClick || handleOnClick}
    >
      {t('common.button.back')}
    </StyledButton>
  )
}

type Props = {
  className?: string
  url?: string
  onClick?: () => void
}

export default ApeironBackButton
